// src/RiderLogin.jsx
import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './RiderLogin.css';
import { checkForActiveRideAndNavigate } from './utils/rideUtils';

const RiderLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const login = async () => {
    if (!email || !password) {
      alert('Please enter email and password');
      return;
    }

    setIsLoading(true);
    try {
      const { user } = await signInWithEmailAndPassword(auth, email, password);
      if (user) {
        alert('Login successful!');
        localStorage.setItem('uid', user.uid);
        localStorage.setItem('userType', 'rider');
        checkForActiveRideAndNavigate({ userId: user.uid, navigate });
      }
    } catch (error) {
      alert(`Login failed: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const resetPassword = () => {
    if (!email) {
      alert('Please enter your email to reset password');
      return;
    }

    sendPasswordResetEmail(auth, email)
      .then(() => alert('Password reset link sent to your email!'))
      .catch((err) => alert(`Error sending reset link: ${err.message}`));
  };

  return (
    <div className="rider-login-container">
      <img src="https://u-gotaxi.co.uk/react-widget/assets/logo_ugo_taxi.png" alt="UGO Logo" className="rider-logo" />
      <h2>Rider Login</h2>

      <div className="input-box">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input-box">
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div className="forgot-link">
        <button onClick={resetPassword}>Forgot Password?</button>
      </div>

      <button className="login-btn" onClick={login} disabled={isLoading}>
        {isLoading ? 'Logging in...' : 'Login as Rider'}
      </button>

      <button className="back-btn" onClick={() => navigate('/')}>
        Back to Role Selection
      </button>
    </div>
  );
};

export default RiderLogin;